import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import BrowsePage from "@/pages/BrowsePage";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SupplierRegisterPage from "@/pages/SupplierRegisterPage";
import SupplierDashboardPage from "@/pages/SupplierDashboardPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import PricingPage from "@/pages/PricingPage";
import BillingSuccessPage from "@/pages/BillingSuccessPage";
import BillingCancelPage from "@/pages/BillingCancelPage";
import PartDetailPage from "@/pages/PartDetailPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { AuthProvider, useAuth } from "@/lib/auth";
import { trackPageView } from "@/lib/analytics";

function RouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackPageView(pathname); }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-6 py-12 text-sm text-neutral-500 font-mono-tech">
        [ Loading... ]
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function AppRoutes() {
  return (
    <>
      <RouteTracker />
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/browse" element={<BrowsePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/suppliers/register" element={<SupplierRegisterPage />} />
      <Route
        path="/suppliers/dashboard/:id"
        element={
          <ProtectedRoute>
            <SupplierDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route path="/admin" element={<AdminDashboardPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/billing/success" element={<BillingSuccessPage />} />
      <Route path="/billing/cancel" element={<BillingCancelPage />} />
      <Route path="/parts/:slug" element={<PartDetailPage />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <AppRoutes />
          <Footer />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#171717",
                border: "1px solid #262626",
                color: "#fff",
                borderRadius: "4px",
                fontFamily: "IBM Plex Sans, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
